var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lazy-bg-img",class:[_vm.imageClass, _vm.imageState],style:(_vm.computedStyle),attrs:{"data-width":_vm.imageWidth,"data-height":_vm.imageHeight,"data-state":_vm.imageState}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }